<template>
  <el-dialog
    title="商品"
    :visible.sync="visible"
    width="45%"
    :close-on-press-escape="false"
    @close="handleClose">
    <el-table
      ref="table"
      v-loading="loading"
      border
      row-key="productId"
      :data="list"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55">
      </el-table-column>
      <el-table-column
        label="商品名称"
        prop="productName">
        <template slot-scope="{row}">
          {{ row.productName }}<span v-if="row.productNameRemark">({{ row.productNameRemark }})</span>
        </template>
      </el-table-column>
      <el-table-column label="监管类别">
        <template slot-scope="{row}">
          <el-tag v-if="row.legalTest === 0">非法检</el-tag>
          <el-tag
            v-if="row.legalTest === 1"
            type="danger">法检</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat('YYYY-MM-DD') }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'AssociateProductModal',
  components: {},
  props: {
    selected: {
      type: Array,
      default() {
        return []
      }
    },
    option: {
      type: Object,
      default() {
        return {
          vendorId: '',
          tradeType: ''
        }
      }
    }
  },
  data() {
    return {
      inited: true,
      loading: false,
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      total: 0,
      multipleSelection: []
    }
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
        if (this.inited) {
          this.inited = false
          this.$nextTick(() => {
            this.selected.forEach(item => {
              this.$refs.table.toggleRowSelection(item, true)
            })
            this.fetchList()
          })
        }
      }
    }
  },
  created() { },
  mounted() {
    // this.fetchList()
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() { },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('product/getproducts', {
        payload: {
          ...this.config,
          ...this.option
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    submit() {
      this.$emit('update:selection', this.multipleSelection)
      this.toggleModal(false)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val // 勾选放在multipleSelection数组中
    }
  }
}
</script>
<style lang="stylus" scoped></style>
